<i18n src="./langs.yaml"></i18n>
<template>
  <!-- <section class="container">
    <div class="step-block">
      <div class="step step1">
        <img :src="step1Img2x" :srcset="getSrcSet1" alt="图片" />
        <div class="desc">
          {{ $t(`step1Desc`) }}
        </div>
      </div>
      <div class="step step2">
        <img :src="step2Img2x" :srcset="getSrcSet2" alt="图片" />
        <div class="desc">
          {{ $t(`step2Desc`) }}
        </div>
      </div>
    </div>
    <div :class="$t(`step3Class`)">
      <img :src="step3Img2x" :srcset="getSrcSet3" alt="图片" />
      <div class="desc3">
        <div class="item">
          {{ $t(`step3Desc1`) }}
        </div>
        <div class="item">
          {{ $t(`step3Desc2`) }}
        </div>
      </div>
    </div>
  </section> -->
  <section class="block">
    <img :src="blockImg2x" :srcset="getBlockSrcSet" alt="图片" />
  </section>
</template>

<script>
import { Jockeys, imgFilter } from '@/utils'

export default {
  name: 'Guide',
  data() {
    return {
      step1Img2x: this.$t('step1Img2x') + imgFilter('', 218),
      step2Img2x: this.$t('step2Img2x') + imgFilter('', 218),
      step3Img2x: this.$t('step3Img2x') + imgFilter('', 218),
      blockImg2x: this.$t('blockImg2x'),
    }
  },
  computed: {
    getSrcSet1() {
      const src3 = this.$t('step1Img3x') + imgFilter('', 218)
      return `${this.step1Img2x} 2x, ${src3} 3x`
    },
    getSrcSet2() {
      const src3 = this.$t('step2Img3x') + imgFilter('', 218)
      return `${this.step2Img2x} 2x, ${src3} 3x`
    },
    getSrcSet3() {
      const src3 = this.$t('step3Img3x') + imgFilter('', 218)
      return `${this.step3Img2x} 2x, ${src3} 3x`
    },
    getBlockSrcSet() {
      const src3 = this.$t('blockImg3x')
      return `${this.blockImg2x} 2x, ${src3} 3x`
    },
  },
  mounted() {
    this.$nextTick(() => {
      // console.log("this.$route.query", this.$route.query)
      // console.log("window.devicePixelRatio", window.devicePixelRatio)
      this.$forceUpdate()
    })
  },
}
</script>

<style lang="scss" scoped>
.container {
  padding: 64px 0px 80px;
  .step-block {
    display: flex;
    justify-content: space-between;
    .step {
      width: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: auto;
        height: 436px;
      }
      .desc {
        width: 320px;
        margin-top: 24px;
        text-align: left;
        color: rgb(20, 21, 26);
        font-family: PingFangHK-Regular;
        font-size: 22px;
        font-weight: normal;
        line-height: 50px;
        transform: scale(0.92);
        text-align: justify;
      }
    }
  }
  .step3-block {
    margin-top: 160px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      margin-left: 10px;
      width: auto;
      height: 436px;
    }
    .desc3 {
      margin-right: 40px;
      .item {
        width: 324px;
        color: rgb(20, 21, 26);
        font-family: PingFangHK-Regular;
        font-size: 24px;
        font-weight: normal;
        line-height: 40px;
        text-align: justify;
      }
      .item + .item {
        margin-top: 50px;
      }
    }
  }
  .step3-block-en {
    align-items: flex-start;
    img {
      margin-top: 12px;
    }
  }
}
.block {
  img {
    width: 750px;
    height: auto;
  }
}
</style>
